var chunkToChildrenMap = {
	"3029": [
		4997,
		5710
	],
	"8546": [
		2931,
		5942,
		1823
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));